/**
 * Redirect legacy `/ai-studio/agents/:agentId/definition` → canonical definition URL.
 */

import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const AIStudioAgentDefinitionRedirect: React.FC = () => {
  const { agentId } = useParams<{ agentId: string }>();
  if (!agentId) {
    return <Navigate to="/ai-studio/agents" replace />;
  }
  return <Navigate to={`/ai-studio/agents/${agentId}`} replace />;
};

export default AIStudioAgentDefinitionRedirect;
